import { environment as base } from "./environment.verv";

export const environment = {
  ...base,
  production: true,
  bugsnagEnv:'Production',
  apiUrl: 'https://verv-prd-memberPortal.azurewebsites.net/api',
  ga: 'G-N2C5EYY59B',
  b2cApiEndpoint: 'https://verv-prd-memberPortal.azurewebsites.net/api/**',
  b2cClientId: '07db882a-decd-42fb-8a87-0a6dd2ed55d6',
  b2cReadScope: 'https://ApexVERV.onmicrosoft.com/5f8e10f5-3ab1-4dcf-9a15-38e5d5afdc26/MemberPortal.User',
  b2cWriteScope: 'https://ApexVERV.onmicrosoft.com/5f8e10f5-3ab1-4dcf-9a15-38e5d5afdc26/MemberPortal.User',
  b2cLogoutUrl: 'https://member.vervesuper.com.au/',
  b2cPolicySignIn: 'B2C_1_MemberPortal_SignUpSignIn',
  b2cSignInAuthority:'https://apexverv.b2clogin.com/apexverv.onmicrosoft.com/B2C_1_MemberPortal_SignUpSignIn',
  b2cPolicyElevatedSignIn: 'B2C_1_MemberPortal_ElevatedSignIn',
  b2cElevatedSignInAuthority:'https://apexverv.b2clogin.com/apexverv.onmicrosoft.com/B2C_1_MemberPortal_ElevatedSignIn',
  b2cAuthorityDomain: 'apexverv.b2clogin.com',
  greenIdEnv:'prod',
  greenIdCode:'Xrv-cUK-rUQ-Ab5',
};
